<!--赖传峰-->
<!--2022/3/30-->
<template>
  <!-- <div class="drive-layout-wrapper"> -->
  <AsyncIpBlocked v-if="ipBlock" />
  <template v-else>
    <ClientOnly>
      <LangChange />
    </ClientOnly>
    <div
      class="drive-layout"
      :class="[isNeedPasscodeClass ? 'need-passcode' : '', classForRouteMap[currentPath]]"
    >
      <template v-if="layoutStore.isMobile">
        <SidebarMobile />
        <AsyncDriveHeaderShareMobile v-if="isSharePath" />
        <AsyncDriveHeaderMobile v-else />
      </template>
      <template v-else>
        <AsyncDriveHeader />
      </template>
      <main class="main">
        <slot />
      </main>
    </div>
  </template>
  <LoginDialog ref="loginDialog" />
</template>

<script
  lang="ts"
  setup
>
import {
  computed,
  defineAsyncComponent,
  provide,
  ref,
  useI18n,
  useRoute,
  useSeoMeta,
  watch,
} from '#imports'
import LoginDialog from '@/layouts/common/LoginDialog.vue'
import { useLayout } from '@/store/layout'
import { useShare } from '@/store/share'
import { useUserInfo } from '@/store/userInfo'
import {
  InjectionKey,
  RoutePath,
  ShareStatus,
  SupportLocale,
} from '@/types/enum'
import {
  type ComputedRef,
  hydrateOnVisible,
} from 'vue'
import { OG_SITE_NAME } from '~/types/constants'
import SidebarMobile from './drive/Sidebar.m.vue'

const locale = useI18n().locale as ComputedRef<SupportLocale>

const loginDialog = ref<InstanceType<typeof LoginDialog>>()
const showLoginDialog: ShowLoginDialog = callback => loginDialog.value?.show(callback)
provide<ShowLoginDialog>(InjectionKey.SHOW_LOGIN_DIALOG, showLoginDialog)

const userInfoStore = useUserInfo()
const layoutStore = useLayout()
const shareStore = useShare()
const route = useRoute()

const AsyncIpBlocked = defineAsyncComponent({
  loader: () => import('@/components/IpBlocked.vue'),
  hydrate: hydrateOnVisible(),
})
const AsyncDriveHeader = defineAsyncComponent({
  loader: () => import('@/layouts/drive/DriveHeader.vue'),
  hydrate: hydrateOnVisible(),
})
const AsyncDriveHeaderMobile = defineAsyncComponent({
  loader: () => import('@/layouts/drive/DriveHeader.m.vue'),
  hydrate: hydrateOnVisible(),
})
const AsyncDriveHeaderShareMobile = defineAsyncComponent({
  loader: () => import('@/layouts/drive/DriveHeader.share.m.vue'),
  hydrate: hydrateOnVisible(),
})

const ipBlock = computed(() => !!userInfoStore.ipBlock)

// 判断路由修改页面样式,兼容多语言路由
const classForRouteMap: Record<string, string> = {
  [RoutePath.INAPP_SHOP]: 'shop-bg',
}
const languages = Object.values(SupportLocale)

const langRegex = new RegExp(`^/(${languages.join('|')})|$`)

const currentPath = computed(() => route.path.replace(langRegex, ''))
const isSharePath = computed(() => /\/s\//.test(route.path))
// FIXME 在 template 中不生效
const isNeedPasscodeClass = computed(() => shareStore.data.share_status === ShareStatus.PASS_CODE_EMPTY)
watch([locale, useRoute()], () => {
  layoutStore.sidebarMobileVisible = false
})
useSeoMeta({
  ogSiteName: OG_SITE_NAME,
})

</script>

<style
  lang="less"
  scoped
>
@import '@/assets/styles/util';

/* .drive-layout-wrapper {
  display: flex;
  flex-direction: column;
  overflow: hidden;
} */

.drive-layout {
  display: flex;
  flex-direction: column;
  #no-select();
  height: var(--vh, 100vh);
  position: relative;
  z-index: 1;
}

.main {
  position: relative;
  flex: 1;
}
</style>

<style lang="less">
@import '@/assets/styles/util';

.shop-bg {

  background: url('@/assets/images/shop/shop-bg.jpg') no-repeat center/cover;
}

@media screen and (min-width: @mobile-break-width) {
  .need-passcode {
    background: url('@/assets/images/share/passcode-bg.jpeg') var(--no-repeat-center)/cover #e1f1fe;

    .header {
      border-bottom: none;
    }
  }
}
</style>
